import { type ImportTaxSettings } from './types';

/**
 * Used when the settings cannot be read (offline, or before the migration is
 * applied). Same figures as the seeded row, so the calculators still work, and
 * the "effective from" date shown on screen makes a stale fallback visible.
 *
 * Source: URA Import & Export FAQs; fees, transport and the customs rate
 * confirmed by Kabex management on 2026-09-20.
 * See docs/ura-tax-methodology.md.
 */
export const defaultImportTaxSettings: ImportTaxSettings = {
  customsRateUgxPerUsd: 3750,
  importDutyPct: 25,
  vatPct: 18,
  withholdingTaxPct: 6,
  infrastructureLevyPct: 1.5,
  importDeclarationFeePct: 1,
  envLevyMinAge: 9,
  envLevyPassengerPct: 50,
  envLevyGoodsPct: 20,
  maxAgePassenger: 15,
  maxAgeGoodsLight: 15,
  maxAgeGoodsHeavy: null,
  registrationFeeUgx: 1218000,
  numberPlatesUgx: 714300,
  personalisedPlatesUgx: 20000000,
  stampDutyUgx: 200000,
  // Nothing imported: the lookup falls back to the bundled copy.
  valuationCount: 0,
  effectiveFrom: '2026-09-20',
  sourceNote:
    'URA Import & Export FAQs; fees and customs rate confirmed by Kabex management 2026-09-20',
  transport: [
    { destination: 'Kampala, Uganda', minKg: 1, maxKg: 1499, amountUsd: 750 },
    { destination: 'Kampala, Uganda', minKg: 1500, maxKg: 1999, amountUsd: 850 },
    { destination: 'Kampala, Uganda', minKg: 2000, maxKg: 4999, amountUsd: 1300 },
    { destination: 'Kampala, Uganda', minKg: 5000, maxKg: 9999, amountUsd: 2200 },
    { destination: 'Kampala, Uganda', minKg: 10000, maxKg: null, amountUsd: 3300 },
    { destination: 'Bunagana, DR Congo', minKg: 1, maxKg: 1499, amountUsd: 1040 },
    { destination: 'Bunagana, DR Congo', minKg: 1500, maxKg: 1999, amountUsd: 1120 },
    { destination: 'Bunagana, DR Congo', minKg: 2000, maxKg: 4999, amountUsd: 1550 },
    { destination: 'Bunagana, DR Congo', minKg: 5000, maxKg: 9999, amountUsd: 2400 },
    { destination: 'Bunagana, DR Congo', minKg: 10000, maxKg: null, amountUsd: 3600 },
    { destination: 'Nimule, South Sudan', minKg: 1, maxKg: 1499, amountUsd: 1040 },
    { destination: 'Nimule, South Sudan', minKg: 1500, maxKg: 1999, amountUsd: 1120 },
    { destination: 'Nimule, South Sudan', minKg: 2000, maxKg: 4999, amountUsd: 1550 },
    { destination: 'Nimule, South Sudan', minKg: 5000, maxKg: 9999, amountUsd: 2400 },
    { destination: 'Nimule, South Sudan', minKg: 10000, maxKg: null, amountUsd: 3600 },
  ],
};
